import { Typography } from '@mui/material';

const statusBarColor = (status: string) => {
  if (status === 'pending') {
    return '#C2BCC7';
  }

  if (status === 'approved') {
    return '#00FF86';
  }

  if (status === 'change') {
    return '#FFAF0F';
  }

  if (status === 'rejected') {
    return '#FF4141';
  }

  if (status === 'cancelled') {
    return '#E9E9EA';
  }

  if (status === 'review_quote') {
    return '#B59E5F';
  }

  if (status === 'archived') {
    return '#4D4D4D';
  }
};

const StatusPill: React.FC<{ status: string }> = ({ status }) => {
  const classes = {
    statusBar: {
      borderRadius: '8px',
      color: status === 'archived' || status === 'rejected' ? '#F1F1F1' : '#2D2926',
      textTransform: 'capitalize',
      padding: '9.5px 16px 6.5px 16px',
      fontSize: '16px',
      display: 'inline-block',
    },
  };

  return (
    <Typography variant="h5" sx={[classes.statusBar, { backgroundColor: statusBarColor(status) }]}>
      {status === 'pending' && 'Pending'}
      {status === 'approved' && 'Approved'}
      {status === 'change' && 'Change Required'}
      {status === 'rejected' && 'Rejected'}
      {status === 'cancelled' && 'Cancelled'}
      {status === 'review_quote' && 'Review'}
      {status === 'archived' && 'Archived'}
    </Typography>
  );
};

export default StatusPill;
